import React from "react";
import { Table } from "react-bootstrap";

const MarkDistributionTable = () => {
  const markDistribution = [
    { grade: "A++", interval: "90-100" },
    { grade: "A+", interval: "80-89" },
    { grade: "A", interval: "70-79" },
    { grade: "A-", interval: "60-69" },
    { grade: "B", interval: "50-59" },
    { grade: "C (Fail)", interval: "Below 50" },
  ];

  return (
    <div className="ms-3">
      <h6 className=" fw-bold text-center">Evaluation</h6>
      <Table bordered size="sm" responsive className="mb-0">
        <thead className="table-primary">
          <tr>
            <th className="py-2" style={{ fontSize: "0.75rem" }}>
              Mark Interval
            </th>
            <th className="py-2" style={{ fontSize: "0.75rem" }}>
              Letter Grade
            </th>
          </tr>
        </thead>
        <tbody>
          {markDistribution.map((item, index) => (
            <tr key={index}>
              <td className="py-1" style={{ fontSize: "0.7rem" }}>
                {item.interval}
              </td>
              <td className="py-1" style={{ fontSize: "0.7rem" }}>
                <span className={``} style={{ fontSize: "0.65rem" }}>
                  {item.grade}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default MarkDistributionTable;
